import TOC_TYPES from '../constants/tocTypes';

const getNextChapter = (flatToc, chapterId) => {
  const currentChapterIndex = flatToc.findIndex((chapter) => chapter.id === chapterId);
  const doesChapterExist = currentChapterIndex !== -1;
  const isLastChapter = currentChapterIndex + 1 === flatToc.length;
  const hasNextElement = doesChapterExist && !isLastChapter;

  if (!hasNextElement) {
    return null;
  }

  const tocItemsAfterCurrentChapter = flatToc.slice(currentChapterIndex + 1);
  const nextChapter = tocItemsAfterCurrentChapter.find(
    (tocElement) => tocElement.type !== TOC_TYPES.TITLE
  );

  return nextChapter;
};

export default getNextChapter;
